"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Linkify = void 0;
var quill_delta_1 = __importDefault(require("quill-delta"));
var linkTypes_1 = require("./linkTypes");
var quillLinkify_1 = require("./quillLinkify");
var Linkify = /** @class */ (function () {
    function Linkify(quill, options) {
        var typeList = [];
        if (!Object.keys(options).length) {
            typeList.push(new linkTypes_1.UrlType(true));
            typeList.push(new linkTypes_1.MailType(true));
            typeList.push(new linkTypes_1.PhoneNumberType(true));
        }
        else if (options) {
            options.url && typeList.push(new linkTypes_1.UrlType(options.url));
            options.mail && typeList.push(new linkTypes_1.MailType(options.mail));
            options.phoneNumber && typeList.push(new linkTypes_1.PhoneNumberType(options.phoneNumber));
        }
        this.quill = quill;
        this.quillLinkify = new quillLinkify_1.QuillLinkify(typeList);
        this.pasteListener();
        this.typeListener();
    }
    Linkify.prototype.pasteListener = function () {
        var _this = this;
        this.quill.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
            if (typeof node.data !== 'string')
                return delta;
            var text = node.data;
            var newDelta = _this.quillLinkify.searchLink(new quill_delta_1.default(), text);
            if (newDelta.ops.length !== 0) {
                delta.ops = newDelta.ops;
            }
            return delta;
        });
    };
    Linkify.prototype.typeListener = function () {
        var _this = this;
        this.quill.on('text-change', function (delta) {
            var ops = delta.ops;
            if (!ops || ops.length < 1 || ops.length > 2)
                return;
            var lastOp = ops[ops.length - 1];
            if (!lastOp.insert ||
                typeof lastOp.insert !== 'string' ||
                !lastOp.insert.match(/\s/)) {
                return;
            }
            _this.quillLinkify.linkifyCurrentLine(_this.quill);
        });
    };
    return Linkify;
}());
exports.Linkify = Linkify;
